import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { alpha, styled } from '@mui/system';
import { getContrastColor } from '#component/theme';
import { uuidv4 } from '#helper';

const StyledMenuItem = styled(MenuItem)({
  minWidth: 150
});

const StyledDeleteMenuItem = styled(MenuItem)(({ theme }) => ({
  minWidth: 150,
  color: theme.palette.error.main
}));

const AddButton = styled('div')({
  '&:before': {
    content: "' '",
    display: 'block',
    width: 20,
    height: 20,
    backgroundColor: '#FFF',
    position: 'absolute',
    left: 3,
    top: 5
  }
});

const DeleteButton = styled('div')({
  position: 'absolute',
  right: 13,
  top: -4
});

const items = [
  {
    label: 'Date',
    name: 'date',
    attr: ['date'],
    getProps: state => ({
      ...state,
      id: state.id || uuidv4(),
      date: new Date().toISOString(),
      minutes: {
        hour: 1
      }
    })
  },
  {
    label: 'Address or location',
    name: 'addressLocation',
    attr: ['address', 'locations', 'company'],
    getProps: state => ({
      ...state,
      id: state.id || uuidv4(),
      company: {},
      address: {},
      formattedAddress: undefined,
      locations: [],
      done: null,
      minutes: {
        hour: 1
      },
      radius: undefined
    })
  }
];

const getMenuItems = (
  index,
  state,
  addState,
  deleteAttrFromState,
  handleClose
) => items.reduce((a, c, i) => {
  if (!c) return a;
  const stateAttr = c.attr.find(attr => state[attr]);
  if (!stateAttr) {
    a.add.push(
      <StyledMenuItem
        key={i}
        onClick={() => {
          addState(c.getProps(state));
          handleClose(1)();
        }}
      >
        {c.label}
      </StyledMenuItem>
    );
  } else if (
    (c.name === 'addressLocation') ||
    (c.name === 'date' && index !== 0)
  ) {
    a.delete.push(
      <StyledDeleteMenuItem
        key={i}
        onClick={() => {
          deleteAttrFromState(c.name === 'date' ? [...c.attr, 'minutes', 'timedelta'] : [...c.attr, 'timedelta', 'minutes', 'radius', 'formattedAddress', 'addressbookContactId', 'id']);
          handleClose(2)();
        }}
      >
        {`Delete ${c.label}`}
      </StyledDeleteMenuItem>
    );
  }
  return a;
}, { add: [], delete: [] });

export default function SimpleMenu(props) {
  const {
    index,
    style,
    addState,
    deleteAttrFromState,
    state = {}, // an empty state renders all items in the add menu
    displayDelete,
    disabled
  } = props;

  const [anchorE1, setAnchorE1] = React.useState(null);
  const [anchorE2, setAnchorE2] = React.useState(null);

  const showDeleteButton = () => {
    if (index !== 0) {
      return true;
    }

    if (state.date && (state.company || state.locations?.length)) {
      return true;
    }

    return false;
  };

  const handleClick = anchorNumber => event => {
    if (anchorNumber === 1) {
      setAnchorE1(event.currentTarget);
    } else {
      setAnchorE2(event.currentTarget);
    }
  };

  const handleClose = anchorNumber => () => {
    if (anchorNumber === 1) {
      setAnchorE1(null);
    } else {
      setAnchorE2(null);
    }
  };

  const displayDeleteButton = showDeleteButton() || displayDelete;

  const MenuItems = getMenuItems(index, state, addState, deleteAttrFromState, handleClose);
  const AddMenuItems = MenuItems.add;
  const DeleteMenuItems = MenuItems.delete;
  return (
    <>
      {!!AddMenuItems.length &&
        <AddButton style={style}>
          <IconButton aria-label="add" disabled={disabled} size="small" onClick={handleClick(1)}>
            <Tooltip title="Add">
              <AddCircleOutlineRoundedIcon style={{
                color: alpha(getContrastColor(), disabled ? 0.6 : 1)
              }}
              />
            </Tooltip>
          </IconButton>
        </AddButton>}
      {displayDeleteButton && !!DeleteMenuItems.length &&
        <DeleteButton>
          <IconButton aria-label="delete" disabled={disabled} size="small" onClick={handleClick(2)}>
            <Tooltip title="Delete">
              <DeleteIcon />
            </Tooltip>
          </IconButton>
        </DeleteButton>}
      <Menu
        id="add-menu"
        anchorEl={anchorE1}
        keepMounted
        open={Boolean(anchorE1)}
        onClose={handleClose(1)}
      >
        {AddMenuItems}
      </Menu>
      <Menu
        id="delete-menu"
        anchorEl={anchorE2}
        keepMounted
        open={Boolean(anchorE2)}
        onClose={handleClose(2)}
      >
        {DeleteMenuItems}
      </Menu>
    </>
  );
}
